import {} from './mutation-types'
import moment from 'moment'
import slug from 'slug'

import { AUTH_SUCCESS, AUTH_ERROR, AUTH_LOGOUT, USER_SUCCESS, USER_ERROR, RESET_AUTH } from './mutation-types'

/**
 * Logs in the given user and returns the user object
 *
 * @param {params} array an array of credentials
 */

export function login({ commit, dispatch }, user) {
  return new Promise((resolve, reject) => {
    this._vm.$http
      .post('/oauth/access_token', {
        grant_type: 'password',
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        username: user.email,
        password: user.password,
        scope: 'app'
      })
      .then(resp => {
         let expires = moment()
          .add(resp.data.expires_in, 'seconds')
          .unix()
        let token = resp.data.access_token + ';' + resp.data.refresh_token + ';' + expires
        localStorage.setItem('token', token)
        commit(AUTH_SUCCESS, token)      
        dispatch('getAuthUser')
        resolve(resp)
      })
      .catch(err => {
        reject(err)  
      })
  })
}

/**
 * Send a password reset email for the given user
 *
 * @param {params} array an array of credentials
 */
export function resetPassword({ commit }, email) {
    return new Promise((resolve, reject) => {
      this._vm.$http
          .post('/password/email', { email: email })
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)           
          }) 
    })
}

/**
 * Query the authenticated user and returns the user object
 */
export function getAuthUser({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('/api/user')
        .then(resp => {
          commit(USER_SUCCESS, resp)
          resolve(resp)
        })
        .catch(err => {
          commit(USER_ERROR, err)
          reject(err)
        })
    })  
}

/**
 * update authenticated user
 */
export function updateUser({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('/api/user', user)
        .then(resp => {
          dispatch('getAuthUser')
          resolve(resp)
        })
        .catch(err => {
          dispatch('getAuthUser')
          reject(err)
        })
    })
}

/**
 * update authenticated user
 */
export function uploadAttachment({ commit, dispatch }, params) {
  let headers = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }

  let formData = new FormData() // eslint-disable-line
  let attachments = []

  params.attachments.forEach((file, idx) => {
    let fileName = slug(file.name)
    params.content.attachments.push({
      file: fileName,
      type: params.type
    })
    formData.append(fileName, file)
  })

  formData.append('content', JSON.stringify(params.content))

  return new Promise((resolve, reject) => {
    this._vm.$http
      .post('/api/attachment', formData, headers)
      .then(resp => {
        if (['user', 'company'].indexOf(params.type)) {
          dispatch('getAuthUser')
        }
        resolve(resp)
      })
      .catch(err => {
        if (['user', 'company'].indexOf(params.type)) {
          dispatch('getAuthUser')
        }
        reject(err)
      })
  })
}

/**
 * update authenticated user
 */
export function deleteAttachment({ commit }, params) {
  return new Promise((resolve, reject) => {
    this._vm.$http
        .delete(`api/attachment/${params.id}`,
        {
          headers: { Impersonate: params.added_by }
        })
        .then(response => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)           
        }) 
  })
}
